import React from 'react';
import Route from './Route';
import {getScreen} from "../../utils";

const PublicRoute = ({path, screen}) => <Route component={getScreen(screen)} path={path} />;

export default PublicRoute